export const LEADS_ROUTE = {
    LEADS_MANAGE: '/Leads/Manage',
    LEADS_MANAGE_LEADOMATIC: '/Leads/ManageLeadomatic',
    LEAD_CREATE: '/Leads/Lead_create',
    LEAD_PROFILE: '/Leads/Lead_profile',
    LEAD_MANAGE_DELIVERY_REQUESTED: '/Leads/ManageDeliveryRequested',
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/contants/routes.contants.js